import {
    LANG_ES,
    langObj,
    PS_SHOPID_ES,
    PS_SHOPID_FR_44,
    PS_SHOPID_FR_77,
    PS_SHOPID_FR_78,
    PS_SHOPID_IT
} from "../../constants";

export default function getLangByShopId (shopId) {
    return langObj[shopId] ? langObj[shopId] : LANG_ES;
}

export function isSpanishUser (shopId) {
    return shopId != PS_SHOPID_FR_44 && shopId != PS_SHOPID_FR_77 && shopId != PS_SHOPID_FR_78 && shopId != PS_SHOPID_IT;
}

export function isB2bUser (shopId) {
    return shopId != PS_SHOPID_ES && shopId != PS_SHOPID_FR_44 && shopId != PS_SHOPID_FR_77 && shopId != PS_SHOPID_FR_78 && shopId != PS_SHOPID_IT;
}

export function isItalianUser (shopId) {
    return shopId == PS_SHOPID_IT;
}

export function isFrenchUser (shopId) {
    return shopId == PS_SHOPID_FR_44 || shopId == PS_SHOPID_FR_77 || shopId == PS_SHOPID_FR_78;
}
